import { Menu as MenuIcon } from "@mui/icons-material";
import {
  AppBar,
  Box,
  IconButton,
  MenuItem,
  Select,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useUserContext } from "../context/UserContext";
import AccountMenu from "./AccountMenu";
import LoadingOverlay from "./LoadingOverlay";

interface HeaderProps {
  sidebarOpen: boolean;
  onSidebarToggle: () => void;
  isMobile: boolean;
  sidebarWidth: number;
}

const Header: React.FC<HeaderProps> = ({
  sidebarOpen,
  onSidebarToggle,
  isMobile,
  sidebarWidth,
}) => {
  const theme = useTheme();

  const {
    clienti,
    user: userData,
    isLoading: userLoading,
    error: userError,
    selectedCliente,
    setSelectedCliente,
  } = useUserContext();

  return (
    <>
      {userLoading && <LoadingOverlay />}
      {!userLoading && !userError && (
        <AppBar
          position="fixed"
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: "background.paper",
            transition: theme.transitions.create(["margin", "width"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            ...(sidebarOpen &&
              !isMobile && {
                ml: `${sidebarWidth}px`,
                width: `calc(100% - ${sidebarWidth}px)`,
              }),
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={onSidebarToggle}
              edge="start"
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>

            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                flexGrow: 1,
                fontWeight: 600,
                color: "inherit",
              }}
            >
              Fracomina - Sellout
            </Typography>
            {userData?.Kind === "Agent" && (
              /* Select di selezione del cliente */
              <Select
                size="small"
                sx={{ mr: 2 }}
                value={selectedCliente?.id || ""}
                onChange={(e) => {
                  const selectedId = Number(e.target.value);
                  const cliente = clienti?.find((c) => c.id === selectedId);
                  if (cliente) {
                    setSelectedCliente(cliente);
                  }
                }}
              >
                {!userLoading && clienti?.length === 0 && (
                  <MenuItem value="" disabled>
                    Nessun cliente disponibile
                  </MenuItem>
                )}
                {!userLoading && clienti?.length! > 0 && (
                  <MenuItem value="" disabled>
                    Seleziona Cliente
                  </MenuItem>
                )}
                {clienti?.map((cliente) => (
                  <MenuItem key={cliente.id} value={cliente.id}>
                    {cliente.usalesmanCustomerName}
                  </MenuItem>
                ))}
              </Select>
            )}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <AccountMenu />
            </Box>
          </Toolbar>
        </AppBar>
      )}
    </>
  );
};

export default Header;
